import React, { useEffect, useState } from 'react';
import Case from '../../interfaces/case';
import FieldItem from '../baseComponents/FieldItem';
import apiClient from '../../axiosClient';
import CaseDetail from '../../interfaces/caseDetail';
import { formatNumberToIndianNotation } from '../../utils/commonUtils';

interface CurrentCaseDetailsPropps {
    case_id: string,
    refresh?: boolean,
    caseDetailData?: CaseDetail[],
}

const styles = {
    caseDetailBox: {
        paddingBottom: '4px',
    }
};

const CurrentCaseDetails: React.FC<CurrentCaseDetailsPropps> = ({ refresh, case_id, caseDetailData }) => {
    const [currentCase, setCurrentCase] = useState<Case>();

    const fetchSelectedCase = async () => {
        try {
            const apiUrl = "/api/v1/case/";
            let response: any = await apiClient.get(apiUrl + case_id);
            if (response.status === 200) {
                response = response.data;
                setCurrentCase(response.case);
            } else {
                alert("Could not get case detail: " + response.data.message);
            }
        } catch (error: any) {
            if (error.response) {
                alert('Error response data:' + error.response.data.message);
            } else if (error.request) {
                alert('No response received:' + error.request);
            } else {
                alert('Error message:' + error.message);
            }
        }
    }

    useEffect(() => {
        fetchSelectedCase();
    }, [case_id, refresh])

    if (!currentCase) return null;

    return (
        <div style={styles.caseDetailBox}>
            <FieldItem fieldName="Customer Name" value={currentCase.customer_name} />
            <FieldItem fieldName="Customer Number" value={currentCase.customer_phone_number} />
            <FieldItem fieldName="Client Reference ID" value={currentCase.client_reference_id} />
            <FieldItem fieldName="Client" value={currentCase.client_name} />
            <FieldItem fieldName="Agency" value={currentCase.agency_name ?? "N/A"} />
            <FieldItem fieldName="DPD Bucket" value={currentCase.dpd_bucket} />
            <FieldItem fieldName="Loan Type" value={currentCase.loan_type} />
            <FieldItem fieldName="Pincode" value={currentCase.pin_code} />
            <FieldItem fieldName="Total Overdue Amount" value={formatNumberToIndianNotation(currentCase.total_due_amount)} />
            <FieldItem fieldName="Principal Outstanding Amount" value={formatNumberToIndianNotation(currentCase.principal_outstanding_amount)} />
            <FieldItem fieldName="Recovered Amount" value={formatNumberToIndianNotation(currentCase.collected_amount ?? 0)} />
            <FieldItem fieldName="Minimum Due Amount" value={formatNumberToIndianNotation(currentCase.min_due_amount)} />
            <FieldItem
                fieldName="Balance Amount"
                value={formatNumberToIndianNotation(currentCase.total_due_amount - (currentCase.collected_amount ?? 0))}
                />
            {caseDetailData?.map((detail) => {
                if (detail.field_type === "TERTIARY") {
                    return (
                        <FieldItem
                            key={detail.field_name}
                            fieldName={detail.field_name}
                            fieldType={detail.field_value_type}
                            value={detail.field_value}
                        />
                    );
                } return null
            })}
        </div>
    );
};

export default CurrentCaseDetails;
